import React from "react";
import { Link } from "react-router-dom";
import NavBg from "../../NavBg/NavBg";
import Members from "../../HomePage/Members/Members";
import OurSalon from "../../HomePage/OurSalon/OurSalon";
import Partners from "../../HomePage/Partners/Partners";
import InstaFeed from "../../HomePage/InstaFeed/InstaFeed";
import HelpNearYou from "../../Help/HelpNearYou";
import TextLocReviews from "../../TextLocReviews/TextLocReviews";
import ServiceWhy from "../../MainServicePages/ServiceWhy/ServiceWhy";
import { Helmet } from "react-helmet";
import HairServiceImg from "../../HairServicePage/HairServiceImg/HairServiceImg";
import Navi1 from "../../HairServicePage/Navi1/Navi1";
import HairServiceCardContain from "../../HairServicePage/HairServiceCard/HairServiceCardContain";

const HairSalonLavelle = () => {
  return (
    <div className="hairSalonLocation">
      <Helmet>
        <meta charSet="utf-8" />
        <title>
          Hair Salon in Lavelle Road – Hair Cut & Styling, Colour & Hair
          Treatments
        </title>
        <meta
          name="description"
          content="SCENT Hair Salon in Lavelle Road – Hair Cut & Styling, Hair
          Colour, Hair Treatments & more services. Book an Appointment
          Today!"
        />
      </Helmet>
      <NavBg />
      <HairServiceImg />
      <Navi1 />
      <HairServiceCardContain />
      <div className="hairSalonLocationWrapper">
        <div className="hairSalonLocationContent">
          <div className="hairSalonLocationTitle">
            <h2>
              Hair Salon in Lavelle Road – Hair Cut & Styling, Colour & Hair
              Treatments
            </h2>
          </div>
          <div className="hairSalonLocationDesp">
            <p>
              SCENT Hair Salon in Lavelle Road – Hair Cut & Styling, Hair
              Colour, Hair Treatments & more services. Book an Appointment
              Today!
            </p>
          </div>
          <div className="hairSalonLocationWelcomeHead">
            <h2>
              Discover the Ultimate Hair Experience at SCENT in Lavelle Road
            </h2>
          </div>
          <div className="hairSalonLocationWelcomePara">
            <p>
              {" "}
              Welcome to SCENT , located in the heart of Lavelle Road,
              Bangalore. Our salon is a sanctuary of luxury and style, dedicated
              to providing exceptional hair care and styling services. At{" "}
              <Link to={"/hair-salon-in-lavelle-road"}>SCENT Hair Salon</Link>,
              we believe that your hair is a reflection of your personality, and
              we are here to help you express yourself with confidence and
              elegance.
            </p>
          </div>
          <div className="hairSalonLocationService">
            <h2>Our Hair Salon Services</h2>
            <div className="hairSalonLocationServiceList">
              <ol>
                <li>
                  <span>Professional Haircuts and Styling:</span> At SCENT
                  Salon, our skilled hairstylists offer precision haircuts and
                  personalized styling that complement your unique features and
                  lifestyle. Whether you desire a classic look or the latest
                  trend, our experts will create a hairstyle that suits you
                  perfectly.
                </li>
                <li>
                  <span>Premium Hair Coloring: </span> Transform your look with
                  our expert hair coloring services. Our colorists specialize in
                  a range of techniques, including highlights, lowlights,
                  balayage, ombre, and full-color treatments. Using high-quality
                  products, we ensure vibrant, long-lasting results that enhance
                  your natural beauty.
                </li>
                <li>
                  <span>Rejuvenating Hair Treatments: </span> Revitalize your
                  hair with our extensive selection of hair treatments. From
                  deep conditioning and keratin treatments to protein and
                  moisture therapies, our treatments are designed to repair
                  damage, add shine, and improve overall hair health.
                </li>
                <li>
                  <span>Bridal and Event Styling: </span> Make your special
                  occasions unforgettable with our bridal and event styling
                  services. Our team creates stunning updos, intricate braids,
                  and elegant styles tailored to your preferences, ensuring you
                  look your best for any event.
                </li>
                <li>
                  <span>Men’s Grooming:</span> Our salon also caters to men with
                  precision haircuts, beard trims, and grooming services. Our
                  barbers provide stylish and sophisticated looks that keep you
                  looking sharp and polished.
                </li>
              </ol>
            </div>
          </div>
          <div className="hairSalonLocationWhy">
            <h2>Why Choose SCENT Hair Salon in Lavelle Road?</h2>
            <div className="hairSalonLocationWhyList">
              <ol>
                <li>
                  <span>Expert Stylists:</span>Our team of highly trained and
                  experienced stylists and colorists are passionate about hair.
                  They stay current with the latest trends and techniques to
                  bring you the best in hair care and styling.
                </li>
                <li>
                  <span>Personalized Services:</span> We take pride in offering
                  personalized attention to each client. Our stylists take the
                  time to understand your needs and preferences, ensuring every
                  service is tailored to your unique requirements.
                </li>
                <li>
                  <span>Quality Products:</span> SCENT uses only premium hair
                  care products known for their effectiveness and gentle care.
                  Our products are selected to provide the best results while
                  maintaining the health of your hair.
                </li>
                <li>
                  <span>Relaxing Atmosphere:</span> Our salon provides a
                  relaxing and welcoming environment where you can unwind and
                  enjoy your beauty treatments. We strive to make every visit a
                  pleasant and stress-free experience.
                </li>
                <li>
                  <span>Convenient Location:</span> Conveniently situated on
                    Lavelle Road, SCENT
                  is easily accessible, making it a perfect choice for both
                  quick touch-ups and extensive beauty treatments.
                </li>
              </ol>
            </div>
          </div>
          <div className="hairSalonLocationBook">
            <h2>Book Your Appointment Today!</h2>
          </div>
          <div className="hairSalonLocationBookPara">
            <p>
              Ready to experience the best in hair care? Book your appointment
              at <span></span>
              <Link to={"/hair-salon-in-lavelle-road"}>
                SCENT Hair Salon in Lavelle Road
              </Link>
              <span> </span>
              .Whether you're looking for a chic haircut, a stunning new color,
              or a restorative treatment, our expert team is here to help you
              achieve your hair goals.
            </p>
            <p>
              Visit <Link to={"/"}>SCENT</Link> and discover why we are the top
              choice for <span></span>
              <Link to={"/hair-salon-in-lavelle-road"}>
                hair care in Lavelle Road
              </Link>
              . We look forward to welcoming you and Lavelle Road
            </p>
          </div>
        </div>
      </div>
      <Members />
      <OurSalon />
      <Partners />
      <InstaFeed />
      <HelpNearYou />
      <TextLocReviews />
      <ServiceWhy />
            
    </div>
  );
};

export default HairSalonLavelle;
